import React, {useEffect, useState} from 'react';
import {SellFactorSCLContext} from "./SellFactorContext";
import objectDataHolder from "../Hooks/ObjectDataHolder";
import SellSclFactorKOL from "./SellSclFactorKOL";
import SellFactorSCLJoz from "./SellFactorSCLJoz";
import "./style.scss"
import axios from "axios";
import {prefixUrl} from "../../utils/utilsData";
import {useLocation} from "react-router-dom";
import utilsFunction from "../../utils/utilsFunction";
import {sumEachRow} from "./components/functions";

export const mySendData = {
  date: "", "id": "", "tax": "", "discount": "",

  "mode": "add", "factorType": "factor", //, preFactor
  "factorStatus": "inProcess", //inProcess accepted, sending, delivered",
  "deliveryId": "", "deliveryName": "", "deliveryType": "",

  "addressId": "", "addressText": "",

  "driverId": undefined, "driverName": "",

  "productsData": [/*{
        "productId": 1,
        "priceId": 1,
        "weight": 2.5,
        "discount": 0,
        "factorStatus": "inProcess, accepted, sending, delivered"
      }*/]
}
export const myInitialData = {
  "deliveryRLookUpId": 0, "addressRLookUpId": 0, "driverRLookUpId": 0, "productData": [/*
        {
        "productId": 1, "productName": "مرغ گرم بسته بندی", "priceList": [{
          "priceId": "11", "price": "50"
        }]
      }, {
        "productId": 2, "productName": "جگر", "priceList": [{
          "priceId": "12", "price": "45"
        }]
      }, {
        "productId": 3, "productName": "دل", "priceList": [{
          "priceId": "13", "price": "46"
        }]
      }, {"productId": 4, "productName": "سنگدان", "priceList": [{
          "priceId": "14", "price": "47"
        }]
      }, {"productId": 5, "productName": "جوجه", "priceList": [{
          "priceId": "15", "price": "48"
        }]
      }, {"productId": 6, "productName": "سینه گرم فله", "priceList": [{
          "priceId": "16", "price": "49"}]
      }, {
        "productId": 7, "productName": "ضایعات پا", "priceList": [{
          "priceId": "17", "price": "40"
        }]
      }, {
        "productId": 8, "productName": "سینه بی پوست گرم", "priceList": [{
          "priceId": "18", "price": "60"
        }]
      }
      */],
}

function SellSclFactor(props) {
  const [data, setData] = objectDataHolder({initialData: myInitialData, sendData: mySendData})
  const getInitialData = async () => {
    try {

      const res = await axios(prefixUrl() + '/SCLFactor/?request=initialData');
      if (res.data.status) {
        const myInitialData = res.data.initialData
        setData({initialData: myInitialData})
        return res.data.initialData
      }
    } catch (error) {
      console.log(error)
    }
  }

  const getNeededData = async () => {
    const myStateId = myLocation?.state?.id
    if (myStateId) {
      try {
        const initialData = await getInitialData()
        const res = await axios.get(prefixUrl() + `/SCLFactor/?request=factorSubmittedData&id=${myStateId}`)
        if (res.data.status) {
          ///setData({sendData: res.data.data})
          const mySendData = {...res.data.data}

          let temp = utilsFunction.addRowIdToTable(mySendData.productsData)
          let temp2 = utilsFunction.addUniqIdToTable(temp)
          let temp3 = sumEachRow(temp)

          mySendData.productsData = [...temp2]
          setData({initialData, sendData: mySendData})
        }
      } catch (error) {
        console.log(error)
      }
    } else {
      getInitialData().then(initialData => {
        setData({initialData: initialData})
      })
    }
  }
  const myLocation = useLocation()
  useEffect(() => {
    void getNeededData()
  }, [])

  try {
    return (<div>

      <SellFactorSCLContext.Provider value={{data, setData}}>
        <div className={"scl__sell__factor"}>
          <div className={"container__scl__factor"}>
            <div className={"SellSclFactorKOL__scl__factor"}>
              <SellSclFactorKOL/>
            </div>
            <div className={"SellFactorSCLJoz"}>
              <SellFactorSCLJoz/>
            </div>
          </div>
        </div>
      </SellFactorSCLContext.Provider>
    </div>);
  } catch (error) {
    return <>{error.toString()}</>
  }
}

export default SellSclFactor;